import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';

import { API, post } from 'utils/api';

const { ACTIONS } = API.END_POINTS.API;

export function requestActivationEmail(params) {
  const url = ACTIONS;

  return (dispatch) => {
    dispatch(showLoading(url));

    return new Promise((resolve, reject) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(window.app.env.CAPTCHA_SITE_KEY, { action: 'email_request' }).then(captchaToken => {
          const dataWithToken = {
            action: 'resend_activation_email_request',
            captchaToken,
            data: params.email
          };

          post(url, { data: dataWithToken }, { suppressAuth: true })
            .then(() => {
              dispatch(hideLoading(url));
              resolve();
            })
            .catch((error) => {
              dispatch(hideLoading(url));
              reject(error);
            });
        });
      });
    });
  };
}
